import { useQuery } from 'react-query';
import { queryUserInfos } from './useUserInfos.query';
import { QueryUserInfosResponse, UseUserInfosOptions } from './useUserInfos.types';

export const USER_INFOS_QUERY_KEY = 'USER_INFOS';

export const useUserInfos = (options?: UseUserInfosOptions) => {
  return useQuery<QueryUserInfosResponse, Error>(USER_INFOS_QUERY_KEY, () => queryUserInfos(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
